"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[715],{

/***/ 26:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Image(props, ref) {
    const { alt , loading , src , ...rest } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: ref,
        srcSet: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildSrcSet */ .fY)(src),
        src: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)(src.url),
        ...rest,
        alt: alt || "",
        decoding: "async",
        loading: loading || "lazy"
    });
}));


/***/ }),

/***/ 5715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HeroSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(608);
/* harmony import */ var _components_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1269);
/* harmony import */ var _components_vimeo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9972);








const focalpoints = {
    bottom: "object-bottom",
    center: "object-center",
    left: "object-left",
    leftBottom: "object-left-bottom",
    leftTop: "object-left-top",
    right: "object-right",
    rightBottom: "object-right-bottom",
    rightTop: "object-right-top",
    top: "object-top",
    custom: ""
};
function HeroSection(param) {
    let { data: { title , cover , backgroundFocalpoint , customFocalpoint , vimeoUrl , overline , videoStartAtSecond  }  } = param;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    const showAnimation = (0,hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_6__/* .useShowAnimation */ .H)(ref);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_3__/* .ContainerSize.full */ .B.full,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative",
            ref: ref,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative overflow-hidden rounded-xl md:rounded-3xl hero-height",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute inset-0",
                        children: [
                            cover && backgroundFocalpoint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("transition duration-[3000ms] h-full w-full object-cover ".concat(focalpoints[backgroundFocalpoint]), {
                                    "opacity-0 scale-110": !showAnimation,
                                    "opacity-100 scale-100": showAnimation
                                }),
                                style: backgroundFocalpoint === "custom" ? {
                                    objectPosition: customFocalpoint
                                } : {},
                                src: cover,
                                height: cover.height,
                                width: cover.width,
                                alt: cover.alternativeText,
                                sizes: "100vw",
                                loading: "eager"
                            }),
                            vimeoUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[100vw] h-[56.25vw] min-w-[177.77vh] min-h-[100vh] absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_vimeo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    url: vimeoUrl,
                                    preset: "no_controls_autoplay",
                                    start: videoStartAtSecond
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute inset-0 bg-blue-400 transition-opacity duration-[2000ms]", {
                                    "opacity-0": !showAnimation,
                                    "opacity-20": showAnimation
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute inset-x-0 bottom-0 -mx-6 md:-mx-12 transition-opacity delay-700 duration-1000", {
                        "opacity-0": !showAnimation,
                        "opacity-100": showAnimation
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-6 md:px-12 grid grid-cols-12 gap-1.5 md:gap-6 pb-16 md:pb-24 m-auto max-w-screen-3xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "col-start-2 lg:col-start-4 col-span-10 lg:col-span-8",
                            children: [
                                overline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "block text-white font-bold text-20 leading-125 md:text-35 md:leading-130",
                                    children: overline
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "block text-white text-40 leading-120 font-bold md:text-50 lg:text-55 xl:text-85 lg:leading-110",
                                    children: title
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShowAnimation; }
/* harmony export */ });
/* harmony import */ var _useOnScreen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4013);

function useShowAnimation(ref) {
    const [, enterCount] = (0,_useOnScreen__WEBPACK_IMPORTED_MODULE_0__/* .useOnScreen */ .R)(ref);
    const showAnimation = enterCount >= 1;
    return showAnimation;
}


/***/ })

}]);